import React, { FC, InputHTMLAttributes } from "react";
import cn from "clsx";
import "./style.scss";

type Props = InputHTMLAttributes<HTMLInputElement> & {
  isChecked: boolean;
  isIndeterminate?: boolean;
};

const SquareRadio: FC<Props> = ({ isChecked, isIndeterminate, ...args }) => (
  <div className="square-radio">
    <input
      className={cn("checkbox_input", {
        checked: isChecked,
        indeterminate: isIndeterminate && !isChecked
      })}
      type="radio"
      name="square-radio"
      value="square-radio"
      checked={isChecked}
      readOnly
      {...args}
    />
  </div>
);
export default SquareRadio;
